<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import { cn } from '@shared/utils';

  const dispatcher = createEventDispatcher<{ change: number }>();
  export let names: { name: string | null; href?: string; order?: number }[];
  export let activeIndex = 0;
  export let align: 'center' | 'left' | 'right' = 'left';
  export let hasBorder = true;
  export let containerClass = '';
  export let tabClass = '';
  export let tabActiveClass = '';

  const handleClick = (val: number) => {
    dispatcher('change', val);
  };
</script>

{#if names.length}
  <div
    class="{cn(
      'no-scrollbar border-default-300 dark:border-dark-400 flex justify-between overflow-x-scroll md:justify-start md:gap-9',
      {
        'border-b': hasBorder,
        'sm:justify-center md:justify-center': align === 'center',
      },
      containerClass,
    )}"
  >
    {#each names as { name, href = null, order = 0 }, index (index)}
      {@const orderIndex = order || index}
      {#if name}
        <svelte:element
          this="{href ? 'a' : 'button'}"
          {href}
          class="{cn(
            'hover:text-default-900 relative inline-block shrink-0 pb-3 font-medium transition-colors duration-300 dark:hover:text-white',
            tabClass,
            {
              [`text-default-900 dark:text-white ${tabActiveClass}`]: activeIndex === orderIndex,
              'text-default-500 dark:text-dark-600': activeIndex !== orderIndex,
            },
          )}"
          on:click="{() => handleClick(orderIndex)}"
          role="{href ? 'link' : 'button'}"
          tabindex="0"
        >
          {name}
        </svelte:element>
      {/if}
    {/each}
  </div>
{/if}
